import React from "react";
import { Link } from "react-router-dom";
import dateFormat from "dateformat";
import { LazyLoadImage } from "react-lazy-load-image-component";
const GridSingleItems = ({ data }) => {
   const SingleData = data?.gift;
    if(!data?.gift){
    return;
  }
  return (
    <>
      <div className="col">
        <div className="card">
          <div className="card-body">
            <LazyLoadImage
              alt="img"
              effect="blur"
              src={`https://api.wlffinance.org/${SingleData?.image}`}
            />
            <h6 className="">{SingleData?.category}</h6>
            <h5>
              <Link
                to={`/user/gift/details/${SingleData?._id}`}
                className="irwGaLabel irwEventTracking irwGaHasFile"
              >
                {SingleData?.title}
              </Link>
            </h5>
            <p>
              <Link
                to={`/user/gift/details/${SingleData?._id}`}
                className="irwGaLabel irwEventTracking irwGaHasFile"
              >
                 {SingleData?.short_dis
              ? SingleData.short_dis.slice(0, 150) +
                (SingleData.short_dis.length >= 150 ? " ....." : "")
              : ""}
              </Link>
              <Link
                to={`/user/gift/details/${SingleData?._id}`}
                className="coninue-btn"
              >
                <i className="fa-solid fa-chevron-right"></i> Continue Reading
              </Link>
            </p>

            <span> {dateFormat(SingleData?.createdAt, "d/m/yyyy")}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default GridSingleItems;